// E³ 組織結果（E3OrgResultPage）で「回答期間を変えたときに、それまでの選択を引き継ぐ」ための純関数
// ------------------------------------------------------------------
// 2026-10-24 の絞り込み欄の並べ替え（① グループ／会社／所属 → ② 回答期間）で、下の ② を変えると上の ① が
// 消えてしまうのを避けるため。所属・属性の選択肢は回答期間の時点の組織情報で決まるので、
// 新しい回答期間の選択肢にあるものだけを残し、無いものはそこから選び直しにする。

const PATH_SEP = '／';

/**
 * 所属①〜⑦ の選択（名前の配列）のうち、新しい回答期間の組織表にある所まで（先頭から）を残す。
 * @param {string[]} parts 引き継ぐ所属の名前（所属①から順）
 * @param {string[]} deptPaths 新しい回答期間の所属の経路一覧（'／' 区切り）
 * @returns {string[]}
 */
export const keepDeptParts = (parts, deptPaths) => {
  const paths = Array.isArray(deptPaths) ? deptPaths : [];
  const src = Array.isArray(parts) ? parts.filter(Boolean) : [];
  const out = [];
  for (let i = 0; i < src.length; i += 1) {
    const p = [...out, src[i]].join(PATH_SEP);
    if (!paths.some((x) => x === p || x.startsWith(p + PATH_SEP))) break;
    out.push(src[i]);
  }
  return out;
};

/**
 * 属性の選択を、新しい回答期間の選択肢にある値だけにする。属性の行（どの属性で絞り込むか）はそのまま残す。
 * @param {Object<string,string[]>} attrs 引き継ぐ属性の選択（{ position: [...], ... }）
 * @param {string[]} rows 属性の行（'' は未選択の行）
 * @param {Object<string,string[]>} optAttrs 新しい回答期間の属性の選択肢
 * @returns {{ attrs: Object<string,string[]>, rows: string[] }}
 */
export const keepAttrs = (attrs, rows, optAttrs) => {
  const opt = optAttrs || {};
  const next = {};
  Object.keys(attrs || {}).forEach((k) => {
    const have = Array.isArray(opt[k]) ? opt[k] : [];
    next[k] = (attrs[k] || []).filter((v) => have.includes(v));
  });
  return { attrs: next, rows: Array.isArray(rows) && rows.length ? rows : [''] };
};
